import StateSettings from './StateSettings';

export default StateSettings;
